<template>
  <div>
    <Main ref="main" :tableData="tableData" :loading="loading">
      <div slot="header">
        <slot name="header"> </slot>
      </div>
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: { orderBatchCode: { type: String, default: '' } },
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderBatchCode) return
      this.loading = true
      this.$api
        .pendingOrderBatchGoodsListApi({ orderBatchCode: this.orderBatchCode })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
